// LOADER
$("[data-loader]").click(function () {
    loader.fadeIn(200);
});

function loaderClose() {
    loader.fadeOut(200);
}

// CLICK BUTTON VALIDATE FORM ON SUBMIT
// adicionar no botão a classe .js_submit e data-form="#ID_FORM"
$(".js_submit").on('click', function(e){
    var form = $($(this).data().form);
    if (form.valid()) {
        form.submit();
    }
});